import BenefitDocumentUpload from "../../../components/BenefitDocumentUpload";
import httpClient from "../../../services/httpClient";
import { useNavigate } from "react-router-dom";
import { useNotification } from "../../../components/NotificationContext";
import { useTranslation } from "react-i18next";

function AddPPWR() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // const { showNotification } = useNotification();

  const apiPath = async (formData, setUploadProgress) => {
    await httpClient.post("/hrdocuments", formData, {
      withAuth: true,
      config: {
        onUploadProgress: (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setUploadProgress(progress);
        },
      },
    });
  };

  return (
    <BenefitDocumentUpload
      submitLabel={t("documentEditor.addPPWR")}
      onSuccess={
        () => {} // showNotification("Dokument PPWR został dodany pomyślnie!", "success")
      }
      onError={(msg) => {} /* showNotification(msg, "error") */}
      apiPath={apiPath}
      category={"ppwr"}
      subCategory="ppwr"
      navigateTo={() => navigate("/administrator/pliki/dokumenty/ppwr")}
    />
  );
}

export default AddPPWR;
